import React, {PropTypes} from 'react';
import DatePicker from 'material-ui/DatePicker';
import TimePicker from 'material-ui/TimePicker';
import ErrorContainer from './ErrorContainer';
import {changeTime, changeDate} from '../../utilites/date';

const zeroTime = new Date();
zeroTime.setHours(0);
zeroTime.setMinutes(0);
zeroTime.setSeconds(0);
zeroTime.setMilliseconds(0);

class FullDatePicker extends React.Component {
  static propTypes = {
    timeFormat: PropTypes.oneOf(['24hr', 'ampm']),
    min: PropTypes.instanceOf(Date),
    value: PropTypes.instanceOf(Date),
    onChange: PropTypes.func.isRequired
  };

  static contextTypes = {
    intl: PropTypes.object,
    muiTheme: PropTypes.object
  };

  state = {
    defaultDate: zeroTime
  };

  setTime(e, val) {
    let {value = new Date(), onChange, onBlur} = this.props;
    if (value == '') {
      value = new Date();
    }
    onChange(changeTime(value, val));
    onBlur();
  }

  setDate(e, val) {
    let {value = new Date(), onChange, onBlur} = this.props;
    if (value == '') {
      value = new Date();
    }
    onChange(changeDate(value, val));
    onBlur();
    this.refs.time.focus();
  }

  render() {
    let {timeFormat, value, min, onFocus, disabled} = this.props;
    let {defaultDate} = this.state;
    let {muiTheme: {textField}, intl} = this.context;

    let style = {
      root: {
        border: `solid 1px ${textField.borderColor}`,
        marginBottom: 16,
        paddingRight: 22,
        display: 'flex',
        justifyContent: 'flex-start'
      },
      date: {
        cursor: 'pointer'
      },
      time: {
        cursor: 'pointer'
      },
      textField: {
        boxSizing: 'border-box',
        width: '100%',
        marginLeft: 22
      }
    };

    return (
      <ErrorContainer id="FullDatePicker" {...this.props}>
        <div style={style.root}>
          <DatePicker hintText="Date"
                      defaultDate={defaultDate}
                      minDate={min}
                      style={style.date}
                      textFieldStyle={style.textField}
                      ref="date"
                      underlineShow={false}
                      disabled={disabled}
                      onFocus={onFocus}
                      formatDate={(date) => (intl.formatDate(date))}
                      value={value}
                      onChange={(e, val) => this.setDate(e, val)}/>
          <TimePicker hintText="Time" format={timeFormat}
                      style={style.time}
                      textFieldStyle={style.textField}
                      disabled={disabled}
                      underlineShow={false}
                      ref="time"
                      onFocus={onFocus}
                      value={value}
                      onChange={(e, val) => {
                        this.setTime(e, val);
                      }}/>
        </div>
      </ErrorContainer>
    );
  }
}

FullDatePicker.defaultProps = {
  timeFormat: '24hr'
};

export default FullDatePicker;




// WEBPACK FOOTER //
// ./src/components/form/FullDatePicker.jsx